module.exports = "<app-aside-nav></app-aside-nav>\n<div class=\"m-grid__item m-grid__item--fluid m-wrapper\">\n\t<router-outlet></router-outlet>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/theme/pages/aside-left-minimize-default-enabled/aside-left-minimize-default-enabled.component.html
// module id = ./src/app/theme/pages/aside-left-minimize-default-enabled/aside-left-minimize-default-enabled.component.html
// module chunks = main